import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomeLink from "./components/HomeLink";
import { auth, db } from "./firebase";
import { onAuthStateChanged, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import {doc, setDoc } from "firebase/firestore";


function App() {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return unsubscribe;
  }, []);

  return (
    <Router>
      <div className="app-root">
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/parents" element={<Parents user={user}/>} />
            <Route path="/account" element={<AccountPage user={user} />} />
            <Route path="/providers" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/safety-disclaimer" element={<SafetyDisclaimer />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

/* --- Placeholder page components (we'll style these later) --- */

function Home() {
  return (
    <div className="home-page">
      <section className="home-hero">
        {/* Logo area */}
        <div className="home-logo-wrapper">
<div className="home-logo-circle">
  <img
    src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
    alt="The Pink Collective logo"
    className="home-logo-image"
  />
</div>

        </div>

        {/* Our Mission section */}
        <div className="home-mission-section">
          <div className="home-pill-title">Our Mission</div>
          <div className="home-mission-card">
            <p>
              At The Pink Collective, our mission is to reimagine safety and support
              the autism community by giving professionals and families the tools they need
              the moment they need them. You will find a thoughtful blend of creativity,
              compassion, and lived expertise woven into every solution we create. Each one
              is built to protect, empower, and inspire confidence. Because you deserve solutions
              that support you every step of the way.
            </p>
          </div>
        </div>

        {/* Two resource boxes */}
        <div className="home-resources-grid">
          <div className="home-resource-card">
            <h3>Resources for ABA Providers</h3>
            <div className="home-card-underline" />
            <p>
              Tools for ABA Providers are coming soon!
            </p>
          </div>

          <div className="home-resource-card">
            <h3>About Safrly</h3>
            <div className="home-card-underline" />
            <p>
             Safrly blends thoughful design with practical safety solutions, linked
             QR tattoos and digital contact cards, to help caregivers feel more prepared
             and confident everyday.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}


function Parents({ user }) {
  const navigate = useNavigate();
  const [showParentDemoComingSoon, setShowParentDemoComingSoon] = useState(false);
  const [cart, setCart] = React.useState([]);

  const addToCart = (productType) => {
    if (!user) {
      navigate("/account");
      return;
    }
    setCart((prevCart) => {
      const existingItem = prevCart.find(
        (item) => item.productType === productType
      );

      if (existingItem) {
        return prevCart.map((item) =>
          item.productType === productType
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [...prevCart, { productType, quantity: 1 }];
    });

    alert("Added to cart!");
  };

  // ✅ FIXED: moved OUTSIDE addToCart
  const removeFromCart = (productType) => {
    setCart((prevCart) =>
      prevCart.filter((item) => item.productType !== productType)
    );
  };

const updateQuantity = (productType, change) => {
  setCart((prevCart) =>
    prevCart
      .map((item) =>
        item.productType === productType
          ? { ...item, quantity: item.quantity + change }
          : item
      )
      .filter((item) => item.quantity > 0) // removes if 0
  );
};

const getProductLabel = (productType) => {
  if (productType === "access_code") return "Access Code";
  if (productType === "tattoos_8") return "Tattoos (8-pack)";
  if (productType === "tattoos_16") return "Tattoos (16-pack)";
  return productType;
};

const handleCartCheckout = async () => {
    if (!user) {
    alert("Please log in before checking out.");
    return;
  }
  try {
    const response = await fetch(
      "https://tpc-backend-g78s.onrender.com/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
body: JSON.stringify({
  items: cart,
  firebaseUid: user.uid,
  customerEmail: user.email,
}),
      }
    );

    const text = await response.text();
    let data;

    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(`Non-JSON response: ${text.slice(0, 200)}`);
    }

    if (!response.ok) {
      throw new Error(data.error || "Checkout failed");
    }

    window.location.href = data.url;
  } catch (error) {
    console.error(error);
    alert(error.message);
  }
};

return (
<div
  className="parents-page"
  style={{ position: "relative" }}
>

    <div className="parents-top-bar">
      <HomeLink />

<button
  onClick={async () => {
    if (user) {
      await signOut(auth);
    } else {
      navigate("/account");
    }
  }}
  style={{
    display: "block",
    margin: "12px auto 0",
    background: "#ff5ab3",
    border: "none",
    borderRadius: "999px",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
  }}
>
  {user ? "Log Out" : "Log In"}
</button>

<p
  style={{
    textAlign: "center",
    marginTop: "8px",
    marginBottom: "0",
    fontSize: "0.9rem",
  }}
>
  {user ? `Logged in as ${user.email}` : "You are not logged in"}
</p>

    </div>

      <section className="parents-header">
        <h1>Safrly</h1>
        <p>
          Tools, demos, and supports to help caregivers stay organized,
          informed, and prepared in day-to-day life.
        </p>
      </section>

      <section className="parents-main-cards">
        <div className="parents-card">
          <h2>Parent Portal Demo</h2>
          <div className="parents-card-underline" />
          <p>
            See how the digital parent portal works.
          </p>
          <button
            className="parents-button"
            onClick={() => setShowParentDemoComingSoon(true)}
          >
            View Parent Demo
          </button>
          {showParentDemoComingSoon && (
  <div
    onClick={() => setShowParentDemoComingSoon(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "relative",
        backgroundColor: "#f9a8d4",
        borderRadius: "24px",
        padding: "2.5rem 3rem",
        width: "min(420px, 80%)",
        textAlign: "center",
        boxShadow: "0 10px 35px rgba(0, 0, 0, 0.25)",
      }}
    >
      <button
        type="button"
        onClick={() => setShowParentDemoComingSoon(false)}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "10px",
          right: "16px",
          border: "none",
          background: "none",
          fontSize: "1.75rem",
          cursor: "pointer",
        }}
      >
        ×
      </button>

      <h2
        style={{
          marginTop: 0,
          marginBottom: "1rem",
        }}
      >
        Coming Soon!
      </h2>

      <p style={{ marginBottom: 0 }}>
        The Safrly Parent Portal Demo is currently in development.
      </p>
    </div>
  </div>
)}
        </div>

        <div className="parents-card">
          <h2>Parent Portal Login</h2>
          <div className="parents-card-underline" />
          <p>
            Already have a QR band or access code?
          </p>
          <a
            href="https://safrly.thepinkcollective.org"
            className="parents-button"
          >
            Go to Parent Portal
          </a>
        </div>
      </section>

      <section className="parents-products">
        <h2>Everyday Tools for Busy Families</h2>

        <div className="parents-product-grid">
          <div className="parents-product-card">
            <h3>Access Codes</h3>
            <button
              className="parents-button"
              onClick={() => addToCart("access_code")}
            >
              Add to Cart
            </button>
          </div>

          <div className="parents-product-card">
            <h3>Temporary Tattoos (8-pack)</h3>
            <button
              className="parents-button"
              onClick={() => addToCart("tattoos_8")}
            >
              Add to Cart
            </button>
          </div>

          <div className="parents-product-card">
            <h3>Temporary Tattoos (16-pack)</h3>
            <button
              className="parents-button"
              onClick={() => addToCart("tattoos_16")}
            >
              Add to Cart
            </button>
          </div>
        </div>

        {/* ✅ UPDATED CART UI */}
<div style={{ marginTop: "2rem" }}>
  <h3>Your Cart</h3>

  {cart.length === 0 ? (
    <p>Cart is empty</p>
  ) : (
    <>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {cart.map((item, index) => (
          <li
  key={index}
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
  }}
>
<span>
  {getProductLabel(item.productType)} (x{item.quantity})
</span>

  <div style={{ display: "flex", gap: "0.5rem" }}>
    {/* ➖ Decrease */}
    <button
      className="parents-button"
      onClick={() => updateQuantity(item.productType, -1)}
      style={{ padding: "0.3rem 0.6rem" }}
    >
      -
    </button>

    {/* ➕ Increase */}
    <button
      className="parents-button"
      onClick={() => updateQuantity(item.productType, 1)}
      style={{ padding: "0.3rem 0.6rem" }}
    >
      +
    </button>

    {/* ❌ Remove */}
    <button
      className="parents-button"
      onClick={() => removeFromCart(item.productType)}
      style={{ padding: "0.3rem 0.8rem", fontSize: "0.9rem" }}
    >
      Remove
    </button>
  </div>
</li>
        ))}
      </ul>

      <button
        className="parents-button"
        onClick={handleCartCheckout}
        style={{ marginTop: "1rem" }}
      >
        Checkout
      </button>
    </>
  )}
</div>
      </section>
    </div>
  );
}

function AccountPage({ user }) {
  const navigate = useNavigate();

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [message, setMessage] = React.useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/parents");
    } catch (error) {
      console.error(error);
      setMessage("Unable to log in. Please check your email and password.");
    }
  };

  const handleCreateAccount = async () => {
    setMessage("");

    if (!email || !password) {
      setMessage("Please enter an email and password.");
      return;
    }

    try {
const userCredential = await createUserWithEmailAndPassword(
  auth,
  email,
  password
);

const newUser = userCredential.user;

await setDoc(
  doc(db, "parents", newUser.uid),
  {
    parentName: "",
    parentEmail: newUser.email,
    parentPhone: "",
    childName: "",
    hasAccess: false,
    createdAt: new Date().toISOString(),
  },
  { merge: true }
);

navigate("/parents");
    } catch (error) {
      console.error(error);

      if (error.code === "auth/email-already-in-use") {
        setMessage("An account already exists with this email.");
      } else if (error.code === "auth/weak-password") {
        setMessage("Password must be at least 6 characters.");
      } else {
        setMessage("Unable to create account.");
      }
    }
  };

  if (user) {
    return (
      <div className="policy-page">
        <HomeLink />

        <h1 className="page-title">Your Account</h1>

        <div className="policy-card">
          <h2>You’re Logged In</h2>
          <div className="policy-underline" />

          <p>{user.email}</p>

          <button
            className="parents-button"
            onClick={() => navigate("/parents")}
          >
            Continue Shopping
          </button>

          <button
            className="parents-button"
            onClick={() => signOut(auth)}
          >
            Log Out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="policy-page">
      <HomeLink />

      <h1 className="page-title">Your Account</h1>

      <div className="policy-card">
        <h2>Log In or Create a Free Account</h2>
        <div className="policy-underline" />

        <p>
          A free account is required before adding products to your cart.
        </p>

        <form onSubmit={handleLogin} className="account-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="account-input"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="account-input"
          />

          <button type="submit" className="parents-button">
            Log In
          </button>
        </form>

        <p>Don't have an account yet?</p>

        <button
          className="parents-button"
          onClick={handleCreateAccount}
        >
          Create Free Account
        </button>

        {message && <p>{message}</p>}
      </div>
    </div>
  );
}

function Providers() {
  return (
    <div className="providers-page">
      <HomeLink />

      {/* Top title & intro */}  
      <section className="providers-header">
        <h1>Provider Resources</h1>
        <p>
          Digital tools and templates to support BCBAs, RBTs, and ABA practices
          in staying organized, compliant, and ready for accreditation.
        </p>
      </section>
      {/* Two main cards: Demo + Portal/Login */}
      <section className="providers-main-cards">
        <div className="providers-card">
          <h2>Provider Portal Demo</h2>
          <div className="providers-card-underline" />
          <p>
            Explore how the provider-facing tools work: organizing client
            information, linking QR codes, and coordinating with caregivers in a
            clear and efficient way.
          </p>
          <div className="providers-button-wrapper">
            <button className="providers-button">
              View Provider Demo
            </button>
          </div>
        </div>

        <div className="providers-card">
          <h2>Provider Login</h2>
          <div className="providers-card-underline" />
          <p>
            Already working with The Pink Collective? Log in to access your
            forms, resources, and client-linked tools in one secure space.
          </p>
          <div className="providers-button-wrapper">
            <button className="providers-button">
              Go to Provider Portal
            </button>
          </div>
        </div>
      </section>

      {/* Products / forms section */}
      <section className="providers-products">
        <h2>Tools for ABA Clinics & Teams</h2>
        <p>
          Coming soon: printable and digital resources designed to make
          accreditation, documentation, and collaboration more manageable.
        </p>

        <div className="providers-product-grid">
          <div className="providers-product-card">
            <h3>Accreditation Checklists</h3>
            <p>
              Structured checklists to help you track documentation, policies,
              and procedures for accreditation or audits.
            </p>
          </div>
          <div className="providers-product-card">
            <h3>Client Information Templates</h3>
            <p>
              Forms and layouts that align with the parent portal, so providers
              and caregivers stay on the same page.
            </p>
          </div>
          <div className="providers-product-card">
            <h3>Staff Organization Tools</h3>
            <p>
              Resources to support onboarding, training, and everyday task
              management for ABA teams.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}


function About() {
  return (
    <div className="about-section">
      <HomeLink />
      <h1 className="page-title">About Us</h1>

      <div className="bio-card">
        <div className="bio-layout">
          <div className="bio-text">
            <h2>Lynsie Boelsche</h2>
            <div className="bio-card-underline" />

            <p>
              Lynsie Boelsche is the founder of The Pink Collective and a Board Certified Behavior Analyst 
              with over nine years of experience working with individuals on the autism spectrum. 
              She is pursuing her second master’s degree in Organizational Communication and Management at Florida State University.
            </p>

            <p>
              Lynsie started The Pink Collective after years of working closely with families and recognizing the ongoing concerns 
              around safety for vulnerable individuals. She often found herself in parent meetings thinking about how those children 
              would stay safe outside of therapy and school. This led her to create a company focused on developing tools that are practical, 
              functional, and designed for real-world use. The company’s first product, Safrly, is a wearable QR code that provides quick 
              access to emergency contact information when it matters most.
            </p>

            <p>
              As the founder, Lynsie leads product development, clinical design, and the overall vision of the brand. She combines her clinical 
              experience, leadership background, and passion for creative problem-solving to build tools that support safety, dignity, and independence.
            </p>

            <p>
              Outside of her professional work, Lynsie is a pink-loving Pilates princess who survives off Dr. Pepper and believes that safety tools 
              can still be beautiful, empowering, and a little bit fun.
            </p>
          </div>

          <img
            src={`${process.env.PUBLIC_URL}/headshot_lynsie.jpeg`}
            alt="Lynsie Boelsche"
            className="bio-photo"
          />
        </div>
      </div>

      <div className="bio-card">
        <div className="bio-layout reverse">
          <div className="bio-text">
            <h2>Susannah Dorrance</h2>
            <div className="bio-card-underline" />

            <p>
              Susannah Dorrance is the co-founder of The Pink Collective. She holds a master’s degree in
              Biology from the University of North Florida and currently works as a professor at Tallahassee
              State College.
            </p>

            <p>
              Susannah helped bring The Pink Collective to life through creativity and technical expertise.
              From building the company’s website to contributing to product design and branding, she plays
              a key role in turning ideas into real, functional tools. Her attention to detail and love for
              creative problem-solving help shape the look, feel, and functionality of the brand.
            </p>

            <p>
              She is passionate about using creativity and technology to build meaningful, practical solutions
              that can support individuals and families in everyday life.
            </p>

            <p>
              Outside of work, Susannah enjoys caring for her plants, spending time with her cat, and
              exploring new crafts and creative projects.
            </p>
          </div>

          <img
            src={`${process.env.PUBLIC_URL}/headshot_susannah.JPG`}
            alt="Susannah Dorrance"
            className="bio-photo"
          />
        </div>
      </div>
    </div>
  );
}

function Contact() {
  return (
    <div className="page">
                  {/*Home link at the top*/}
        <HomeLink />
      <h2>Contact Us</h2>
      <p>For any information or questions contact us at support@thepinkcollective.org
      </p>
    </div>
  );
}

function PrivacyPolicy() {
  return (
    <div className="policy-page">
            {/*Home link at the top*/}
        <HomeLink />
      <h1 className="page-title">Privacy Policy</h1>
      <div className="policy-card">
        <p>
         The Pink Collective ("we", "our", or"us") respects your privacy and is committed
         to protecting your personal information. This Privacy Policy explains
         how we collect, use, and safeguard your information when you visit our
         website or use our products and services, including Safrly products.
         </p>

         <p>
          By using our websit or products, you agree to the terms of
          this Privacy Plicy.
         </p>

         <p>Effective Date: March 23, 2026</p>

         <p>Last updated: March 23, 2026</p>
      </div>

      <div className="policy-card">
        <h2>Information We Collect</h2>
        <div className="policy-underline" />

        <p>
          We may collect the following types of information:
        </p>

        <ul>
          <li>
            <strong>Personal Information</strong>
            <ul>
              <li>Name</li>
              <li>Email</li>
              <li>Shipping and billing address</li>
              <li>Payment information (processed through third-party providers)</li>
            </ul>
          </li>
          <li>
            <strong>Safrly User-Provided Information</strong>
            <ul>
              <li>If you use Safrly products, you may voluntarily provide:</li>
              <ul>
                <li>Emergy contact information</li>
                <li>Names or identifying information</li>
                <li>Other details you choose to store via QR-linked profiles</li>
              </ul>
            </ul>
          </li>
        </ul>

      <p><em>Note:</em> You are responsible for the accuracy and appropriateness
          of any information you provide. You may update or modify this information
          at any time through your account or designated platform.
      </p>
      </div>

      <div className="policy-card">
        <h2>How We Use Your Information</h2>
        <div className="policy-underline" />

        <p>
          We may use your information to:
          <ul>
            <li>Process orders and transactions</li>
            <li>Provide customer support</li>
            <li>Deliver and improve our products and services</li>
            <li>Enable functionality of Safrly QR-linked information</li>
            <li>Communicate updates, promotions, or important notices</li>
          </ul>
        </p>

        <p>
          We will only use your information in accordance with this 
          Privacy Policy and applicable laws.
        </p>
      </div>

            <div className="policy-card">
        <h2>Safrly Data Use &amp; Responsibility</h2>
        <div className="policy-underline" />

        <p>
          Safrly products allow users to store and share information
          via QR code access.
        </p>

        <p>
          By using Safrly:
          <ul>
            <li>
              You understand that information linked to QR codes
              may be accessible to others who scan the code.
            </li>
            <li>
              You are responsible for ensuring the information is accurate, 
              approriate, and up to date.
            </li>
            <li>
              You are able to access, update, and manage your Safrly-linked
              information at any time through your accont or designated platform.
            </li>
            <li>
              We do not verify, monitor, or guarantee the accuracy of 
              user-provided data.
            </li>
          </ul>
        </p>

        <p>
          <em>Note:</em> The Pink Collective is not responsible for 
          outdated, incorrect, or misused information stored by users.
        </p>
      </div>

        <div className="policy-card">
        <h2>How We Protect Your Information</h2>
        <div className="policy-underline" />

        <p>
          We implement reasonable safeguards to protect your information,
          including:
          <ul>
            <li>Secure hosting environments</li>
            <li>Encryption where applicable</li>
            <li>Limited access to sensitive data</li>
          </ul>
        </p>

        <p>
          While we take reasonable measures to protect your information,
          no method of transmission or storage is completely secure, and
          we cannot guarantee absolute security.
        </p>

        <p>
          To the fullest extent permitted by law, The Pink Collective shall
          not be liable for any unauthorized access to, or disclosure of, 
          personal information resulting from circumstances beyond our 
          reasonable control.
        </p>
      </div>

        <div className="policy-card">
        <h2>Sharing of Information</h2>
        <div className="policy-underline" />

        <p>
          We do not sell or rent your personal information to 
          third parties.
        </p>

        <p>
          We may share information with:
          <ul>
            <li>Payment processors (Stripe)</li>
            <li>Shipping providers</li>
            <li>Service providers who help operate the business</li>
          </ul>
        </p>

        <p>
          These third parties are only given the information 
          necessary to perform their functions.
        </p>
      </div>

        <div className="policy-card">
        <h2>Cookies &amp; Tracking Technologies</h2>
        <div className="policy-underline" />

        <p>
          We may use cookies and similar technologies to:
          <ul>
            <li>Improve website functionality</li>
            <li>Analyze site traffic and usage</li>
            <li>Enhance user experience</li>
          </ul>
        </p>

        <p>
          You can adjust your browser settings to disable cookies
           if desired.
        </p>
      </div>

        <div className="policy-card">
        <h2>Children's Privacy</h2>
        <div className="policy-underline" />

        <p>
          Our products may be used by or for children. However:
          <ul>
            <li>We do not knowingly collect personal information directly
              from children under the age of 13.
            </li>
            <li>Safrly products and associated data are intended to be
              set up and managed by a parent, guardian, or responsible adult.
            </li>
            <li>By providing information through our website or Safrly 
              platform, you represent that you are a parent, guardian, 
              or authorized adult with the right to provide that information.
            </li>
          </ul>
        </p>

        <p>
          We do not independently verify the age or identity of users 
          and rely on individuals to provide accurate information.
        </p>
      </div>

        <div className="policy-card">
        <h2>Your Rights &amp; Choices</h2>
        <div className="policy-underline" />

        <p>
          You may:
          <ul>
            <li>Request access to your personal information</li>
            <li>Request updates or corrections</li>
            <li>Request deletion of your data (where applicable)</li>
            <li>Access, update, or modify your Safrly-linked information 
              directly through your account or designated platform at 
              any time
            </li>
          </ul>
        </p>

        <p>
          You may opt out of receiving marketing or promotional communications
          from us at any time by following unsubscribe instructions or contacting 
          us directly.
        </p>

        <p>
          To make a request, contact us at: support@thepinkcollective.org
        </p>
      </div>

        <div className="policy-card">
        <h2>Data Retention</h2>
        <div className="policy-underline" />

        <p>
          We retain personal information only as long as necessary to:
          <ul>
            <li>Fulfill orders</li>
            <li>Provide services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </p>
      </div>

        <div className="policy-card">
        <h2>Third-Party Links</h2>
        <div className="policy-underline" />

        <p>
          Our website may contain links to third-party websites. 
          We are not responsible for their privacy practices.
        </p>
      </div>

        <div className="policy-card">
        <h2>Changes to This Policy</h2>
        <div className="policy-underline" />

        <p>
          We may update this Privacy Policy at any time. 
          Changes will be posted on this page with an updated date. 
          We encourage you to review this Privacy Policy periodically.
        </p>
      </div>

        <div className="policy-card">
        <h2>Contact</h2>
        <div className="policy-underline" />

        <p>
          If you have any questions about this Privacy Policy, contact 
          us at: support@thepinkcollective.org
        </p>
      </div>
    </div>
  );
}

function Terms() {
  return (
    <div className="page">
            {/*Home link at the top*/}
        <HomeLink />
      <h2>Terms &amp; Conditions</h2>
      <p>Terms &amp; conditions placeholder.</p>
    </div>
  );
}

function SafetyDisclaimer() {
  return (
    <div className="policy-page">
            {/*Home link at the top*/}
        <HomeLink />
      <h1 className="page-title">Safety Disclaimer</h1>

      <div className="policy-card">
        <h2>Placeholder</h2>
        <div className="policy-underline" />

        <p>
          Will be updated.
        </p>
      </div>
    </div>
  );
}

function ReturnPolicy() {
  return (
    <div className="policy-page">
            {/*Home link at the top*/}
        <HomeLink />
      <h1 className="page-title">Return Policy</h1>

      <div className="policy-card">
        <h2>Placeholder</h2>
        <div className="policy-underline" />

        <p>
          Will be updated.
        </p>
      </div>
    </div>
  );
}

function SuccessPage() {
  return (
    <div className="policy-page">
      <HomeLink />
      <h1 className="page-title">Thank You!</h1>

      <div className="policy-card">
        <h2>Payment Successful</h2>
        <div className="policy-underline" />
        <p>
          Your order was received successfully.
        </p>
        <p>
          If you purchased an access code, it will be processed shortly.
        </p>
        <p>
          If you purchased temporary tattoos, your order details have been recorded.
        </p>
      </div>
    </div>
  );
}

export default App;
